















import {Vue, Component} from 'vue-property-decorator';
import ResumeTimeline from '@/components/ResumeTimeline.vue';
import EducationTimeline from '@/components/EducationTimeline.vue';
import MobileResume from '@/components/MobileResume.vue';

@Component({
    name: 'MyResume',
    components: {MobileResume, EducationTimeline, ResumeTimeline},
})
export default class MyResume extends Vue {

}
